<template>
  <section>
    <!-- START EDIT MODAL -->
    <div
      class="modal fade"
      tabindex="-1"
      :id="userType + 'uploadPhotos'"
      role="dialog"
      :aria-labelledby="userType + 'uploadPhotos'"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog--edit" role="document">
        <div class="modal-content edit-modal pt-0 px-0">
          <div class="modal-body text-center my-0">
            <div :id="userType + 'imageNameInputContainer'">
              <div class="mb-2" for="imageName">
                {{ 'Photo Name' | translate }}
              </div>
              <input
                :id="userType + 'imageName'"
                type="text"
                v-model="modalImage.photoName"
                class="form-control"
              />
            </div>
            <div class="bg-white border-top border-right border-left">
              <img class="img-modal" :src="dataURItoBlob(modalImage.base64)" />
            </div>
            <div :id="userType + 'commentContainer'" class="input-group" transition="fade">
              <textarea
                rows="3"
                v-model="modalImage.comment"
                maxlength="100"
                class="form-control mb-3"
              ></textarea>
            </div>
            <div class="row d-flex">
              <div class="col-md-12 order-2 order-md-1">
                <button type="button" class="btn-cancel-modal mt-2" data-dismiss="modal">
                  {{ 'Cancel' | translate }}
                </button>
              </div>
              <div class="col-md-12 order-1 order-md-2 mb-2 mb-md-0">
                <button
                  type="button"
                  class="btn btn-primary btn-full--sm pull-right"
                  @click="addComment(modalImage)"
                  data-dismiss="modal"
                >
                  {{ 'Submit' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END EDIT MODAL -->

    <!-- START FILTER MODAL -->
    <div
      class="modal fade"
      id="filter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content edit-modal">
          <h2 class="h2 text-center mt-3 mt-md-0 mb-3" id="exampleModalLabel">
            {{ 'Filter By' | translate }}
          </h2>
          <div class="modal-body my-0 pt-0">
            <div class="form-group">
              <select class="form-control" id="exampleSelect1" v-model="filterEval">
                <option value="">{{ 'Select Evaluation' | translate }}</option>
                <option
                  v-for="(evaluation, index) in evaluations"
                  :key="index"
                  :value="evaluation._id"
                >
                  {{ evaluation.name }}
                </option>
              </select>
            </div>
            <div class="form-group mb-4">
              <select class="form-control" id="exampleSelect2" v-model="filterAssessor">
                <!--@TODO These should not be hardcoded -->
                <option value="">{{ 'Select Assessor' | translate }}</option>
                <option value="1">{{ 'Hygiene/Footbath' | translate }}</option>
                <option value="2">{{ 'Freestall' | translate }}</option>
                <option value="3">{{ 'Locomotion' | translate }}</option>
                <option value="4">{{ 'Time Budget' | translate }}</option>
                <option value="11">{{ 'Holding Area' | translate }}</option>
                <option value="14">
                  {{ 'Nutrition and Feeding' | translate }}
                </option>
                <option value="13">
                  {{ 'Tiestall Stanchion/Heat Abatement' | translate }}
                </option>
                <option value="15">{{ 'Hoof Trimming' | translate }}</option>
                <option value="17">{{ 'Lesion' | translate }}</option>
                <option value="18">{{ 'Walking Surface' | translate }}</option>
                <option value="9">
                  {{ 'Races, Tracks and Lanes' | translate }}
                </option>
                <option value="12">
                  {{ 'Freestall Ventilation' | translate }}
                </option>
                <option value="10">
                  {{ 'Tie Stall/Stanchion' | translate }}
                </option>
                <option value="16">{{ 'Heat Abatement' | translate }}</option>
                <option value="7">{{ 'Bedded Pack' | translate }}</option>
                <option value="5">{{ 'Dirt Lot' | translate }}</option>
              </select>
            </div>
            <div class="row mx-0">
              <div
                class="col-md-12 px-0 order-2 order-md-1 d-flex justify-content-center d-md-block text-md-center"
              >
                <button type="button" class="btn-cancel-modal mt-2" data-dismiss="modal">
                  {{ 'Cancel' | translate }}
                </button>
              </div>
              <div class="col-md-12 px-0 order-1 order-md-2 mb-2 mb-0">
                <button
                  type="button"
                  class="btn btn-primary btn-full--sm pull-right"
                  data-dismiss="modal"
                  @click="filter()"
                >
                  {{ 'Apply' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END FILTER MODAL -->

    <div class="row mx-md-0 mt-md-3 mt-lg-0">
      <div class="col">
        <!-- START DESKTOP VERSION -->
        <div class="d-none d-md-block mb-0">
          <div id="evaluationAccordions" data-children=".item">
            <div id="columns" class="row d-none d-sm-none d-md-flex">
              <div class="offset-4 col-6 heading">
                <span class="pointer" @click="sort('evaluationName')">
                  {{ 'Evaluations' | translate }}
                  <img
                    class="ml-1 sort"
                    src="@/assets/icons/Sortiicon.svg"
                    alt="sort by evaluation"
                  />
                </span>
              </div>

              <div class="col-4 heading">
                <span class="pointer" @click="sort('groupName')">
                  {{ 'Groups' | translate }}
                  <img class="ml-1 sort" src="@/assets/icons/Sortiicon.svg" alt="sort by group" />
                </span>
              </div>

              <div class="col-4 heading">
                <span class="pointer" @click="sort('assessorName')">
                  {{ 'Assessors' | translate }}
                  <img
                    class="ml-1 sort"
                    src="@/assets/icons/Sortiicon.svg"
                    alt="sort by assessor"
                  />
                </span>
              </div>
              <div class="col-5 heading">
                <span class="pointer" @click="sort('time')">
                  {{ 'Date' | translate }}
                  <img class="ml-1 sort" src="@/assets/icons/Sortiicon.svg" alt="sort by time" />
                </span>
              </div>
            </div>
            <div class="item item--white mt-3">
              <div v-if="images === null || (isCustomer && !isLoaded)">
                <div class="loading loading--sm">
                  <div class="double-bounce1"></div>
                  <div class="double-bounce2"></div>
                </div>
              </div>
              <div v-else-if="images.length === 0" class="mt-4 alert alert-danger">
                <p class="mb-0">
                  {{ 'No images have been uploaded!' | translate }}
                </p>
              </div>
              <div
                v-else
                v-for="(image, index) in images"
                :key="index"
                class="row grey py-2 mt-3 d-flex align-items-center"
              >
                <div class="col-6 my-1 col-md-4">
                  <div @click="toggleModal(image)" class="view-img-my-photos text-center">
                    <img
                      class="img-my-photos"
                      :src="dataURItoBlob(image.base64)"
                      data-toggle="modal"
                      :data-target="'#' + userType + 'uploadPhotos'"
                    />
                  </div>
                </div>
                <div class="col-7 my-2 col-md-6">
                  <div class="heading">
                    {{ image.evaluationName }}
                  </div>
                </div>
                <div class="my-2 d-md-block d-none col-md-4">
                  <div class="heading">
                    {{ image.groupName }}
                  </div>
                </div>
                <div class="col-7 my-2 col-md-4">
                  <div class="heading">
                    {{ image.assessorName }}
                  </div>
                </div>
                <div class="my-2 d-md-block d-none col-md-4">
                  <div class="heading">
                    {{ $store.getters.getDate(image.date_created) }}
                  </div>
                </div>
                <div class="col-4 my-2 col-md-2 text-center">
                  <modal-ellipsis-blue :value="userType + index" class="pull-right">
                    <template slot="modal-title">
                      {{ 'What Would You Like To Do?' | translate }}
                    </template>
                    <template slot="modal-content">
                      <button
                        class="btn btn-full btn-full--modal mb-2"
                        @click="toggleModal(image)"
                        data-dismiss="modal"
                        data-toggle="modal"
                        :data-target="'#' + userType + 'uploadPhotos'"
                      >
                        {{ 'Edit' | translate }}
                      </button>
                      <button
                        data-dismiss="modal"
                        data-toggle="modal"
                        :data-target="['#' + userType + '-areYouSure-' + index]"
                        class="btn btn-full btn-full--modal"
                      >
                        {{ 'Delete' | translate }}
                      </button>
                      <div class="row">
                        <div class="col-md-24 modal-bottom mt-2">
                          <button class="btn-cancel-modal" data-dismiss="modal">
                            {{ 'Cancel' | translate }}
                          </button>
                        </div>
                      </div>
                    </template>
                  </modal-ellipsis-blue>
                  <div
                    class="modal fade"
                    :id="[userType + '-areYouSure-' + index]"
                    tabindex="-1"
                    role="dialog"
                    :aria-labelledby="[userType + '-areYouSure-' + index]"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog" role="document">
                      <div class="modal-content edit-modal">
                        <h2 class="h2 h2--modal text-center mt-3 mt-md-0">
                          {{ 'Are you sure?' | translate }}
                        </h2>
                        <div class="modal-body my-0">
                          <a
                            @click="deleteImage(image)"
                            href="#"
                            data-dismiss="modal"
                            class="btn btn-primary w-100 mb-2"
                            >{{ 'Yes' | translate }}</a
                          >
                          <a
                            href="#"
                            data-dismiss="modal"
                            class="btn btn-secondary mb-2 btn-full"
                            >{{ 'No' | translate }}</a
                          >
                          <div class="row mt-2">
                            <div class="col-md-24 modal-bottom">
                              <a href="#" class="btn-cancel-modal" data-dismiss="modal">{{
                                'Cancel' | translate
                              }}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END DESKTOP VERSION -->

        <!-- mobile -->
        <div
          v-if="images !== null && images.length === 0"
          class="alert alert-danger d-md-none mt-3"
        >
          <p class="mb-0">{{ 'No images have been uploaded!' | translate }}</p>
        </div>

        <div class="item mt-3 d-md-none" v-for="(image, index) in images" :key="index">
          <div class="accordion-heading--wrapper">
            <div :id="['image-' + index]" class="accordion-heading row mx-0">
              <div
                class="open-eval col-3 col-sm-2 col-lg-1"
                data-toggle="collapse"
                :href="['#imageAccordion' + index]"
                aria-expanded="false"
                :aria-controls="['imageAccordion' + index]"
              >
                <i class="fa fa-angle-up fa-angle-up--eval" aria-hidden="true"></i>
                <i class="fa fa-angle-down fa-angle-down--eval" aria-hidden="true"></i>
              </div>
              <div class="col-13 d-flex align-items-center">
                <div class="heading">
                  {{ image.evaluationName }}
                </div>
              </div>
              <div class="col-8">
                <!-- <img class="img-my-photos pull-right" :src="image.url" @click="toggleModal(image)" data-toggle="modal" data-target="#uploadPhotos"> -->
                <div class="view-img-my-photos--mobile d-flex justify-content-center pull-right">
                  <img
                    class="img-my-photos"
                    :src="dataURItoBlob(image.base64)"
                    @click="toggleModal(image)"
                    data-toggle="modal"
                    data-target="#uploadPhotos"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- end accordion-heading--wrapper -->
          <div :id="['imageAccordion' + index]" class="collapse pt-1 pb-3 pb-sm-0" role="tabpanel">
            <div class="row evaluations-row d-md-none mx-0">
              <div class="col-md-2">
                <!-- <img class="img-my-photos" :src="image.url" @click="toggleModal(image)" data-toggle="modal" data-target="#uploadPhotos"> -->
                <div class="row my-2 evaluations-row background-dark-grey">
                  <div class="col-22 py-0">
                    <h3 class="h3 mb-0">
                      {{ 'Assessors & Groups' | translate }}
                    </h3>
                  </div>
                </div>
                <h3 class="h3">{{ image.groupName }}</h3>
                <h3 class="h3">{{ image.assessorName }}</h3>
                <p class="p--large 3">
                  {{ $store.getters.getDate(image.date_created) }}
                </p>
                <button
                  data-dismiss="modal"
                  data-toggle="modal"
                  :data-target="['#' + userType + '-areYouSure2-' + index]"
                  class="btn btn-primary btn-full--sm"
                >
                  {{ 'Delete' | translate }}
                </button>
              </div>
            </div>
          </div>
          <!-- end evaluationAccordion -->

          <div
            class="modal fade"
            :id="[userType + '-areYouSure2-' + index]"
            tabindex="-1"
            role="dialog"
            :aria-labelledby="[userType + '-areYouSure-' + index]"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content edit-modal">
                <h2 class="h2 h2--modal text-center mt-3 mt-md-0">
                  {{ 'Are you sure?' | translate }}
                </h2>
                <div class="modal-body my-0">
                  <a
                    @click="deleteImage(image)"
                    href="#"
                    data-dismiss="modal"
                    class="btn btn-primary w-100 mb-2"
                    >{{ 'Yes' | translate }}</a
                  >
                  <a href="#" data-dismiss="modal" class="btn btn-secondary mb-2 btn-full">{{
                    'No' | translate
                  }}</a>
                  <div class="row mt-2">
                    <div class="col-md-24 modal-bottom">
                      <a href="#" class="btn-cancel-modal" data-dismiss="modal">{{
                        'Cancel' | translate
                      }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end mobile accordion -->
      </div>
    </div>
  </section>
</template>

<script>
import Status from '@/components/evaluations/status';
import ModalEllipsisBlue from '@/components/misc/modal-ellipsis-blue';
import {
  GET_CUSTOMER_EVALUATIONS,
  GET_EVALUATIONS_BY_ID_GETTER,
  GET_EVALUATION_BY_ID,
  GET_UPDATE_ASSESSOR,
  GET_UPDATE_CUSTOMER,
  GET_UPDATE_ME,
  GET_USER_EVALUATIONS,
} from '../../store/types';
import { mapActions, mapGetters, mapState } from 'vuex';
import photosHandlingMixin from '@/mixins/photosHandlingMixin.js';
import imageUploadFn from '@/mixins/imageUploadFn.js';

export default {
  components: {
    Status,
    ModalEllipsisBlue,
  },
  props: {
    user: {
      type: Object,
      default() {
        return {};
      },
    },
    isLoaded: {
      type: Boolean,
      default: true,
    },
    isCustomer: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [photosHandlingMixin, imageUploadFn],
  data() {
    return {
      assessor: null,
      assessors: null,
      evaluations: null,
      filterEval: '',
      filterAssessor: '',
      groups: null,
      images: null,
      medias: [],
      modalImage: {},
      notFiltered: true,
      orderBy: 'asc',
      showComment: false,
      sortedBy: 'time',
      userType: null,
      evaluations: {},
      group: {},
    };
  },
  computed: {
    sorted() {
      return this.orderBy == 'asc' ? 'fa fa-chevron-up' : 'fa fa-chevron-down';
    },
    ...mapState({
      loggedInUser: (state) => state.users.user,
    }),
    ...mapGetters('evaluations', [GET_EVALUATIONS_BY_ID_GETTER]),
  },
  metaInfo: {
    title: 'Evaluations',
  },
  methods: {
    ...mapActions('users', [GET_UPDATE_ME, GET_UPDATE_CUSTOMER]),
    ...mapActions('evaluations', [GET_USER_EVALUATIONS]),
    ...mapActions('assessors', [GET_UPDATE_ASSESSOR]),

    async getUserData() {
      try {
        this.medias = this.user.medias;
        if (this.loggedInUser._id !== this.user._id) {
          this.userType = 'customer';
          // this.evaluations = this[GET_EVALUATION_BY_ID](this.user._id);
          this.evaluations = await this[GET_USER_EVALUATIONS](this.user._id);
          // GET_USER_EVALUATIONS_GETTER
        } else {
          this.userType = 'user';
          this.evaluations = this[GET_EVALUATIONS_BY_ID_GETTER](this.user._id);
        }
        this.getMedia();
      } catch (error) {
        this.$store.state.dataLoaded = true;
        console.warn('Error: ', error);
      }
    },

    // getDate(timestamp) {
    //   let date = new Date(timestamp);
    //   var monthNames = [
    //     this.$t('Jan.'),
    //     this.$t('Feb.'),
    //     this.$t('Mar.'),
    //     this.$t('Apr.'),
    //     this.$t('May'),
    //     this.$t('Jun.'),
    //     this.$t('Jul.'),
    //     this.$t('Aug.'),
    //     this.$t('Sep.'),
    //     this.$t('Oct.'),
    //     this.$t('Nov.'),
    //     this.$t('Dec.'),
    //   ];
    //   var day = date.getDate();
    //   var monthIndex = date.getMonth();
    //   var year = date.getFullYear();
    //   return day + ' ' + monthNames[monthIndex] + ' ' + year;
    // },

    assignMedia() {
      this.assessors.forEach((assessor) => {
        let buildMedias = [];
        let foundMedia = {};
        if (typeof assessor.data.medias !== 'undefined') {
          assessor.data.medias.forEach((mediasID) => {
            foundMedia = this.medias[mediasID];
            buildMedias.push(this.medias[mediasID]);
          });
          assessor.data.medias = buildMedias;
        }
      });
    },

    sort(key) {
      if (this.sortedBy == key) {
        if (this.orderBy == 'asc') {
          this.orderBy = 'desc';
        } else {
          this.orderBy = 'asc';
        }
      } else {
        this.orderBy = 'asc';
      }
      this.images.sort((a, b) => {
        if (a[key] < b[key]) {
          if (this.orderBy == 'asc') {
            return -1;
          } else {
            return 1;
          }
        } else if (a[key] > b[key]) {
          if (this.orderBy == 'asc') {
            return 1;
          } else {
            return -1;
          }
        } else {
          return a.sortingID - b.sortingID;
        }
      });
      this.sortedBy = key;
    },

    async deleteImage(image) {
      // this.evaluation = this.evaluations.find(
      //   e => e._id === image.evaluationID
      // );
      // this.group = this.groups.find(g => g.id === image.groupID);
      // this.assessor = this.assessors.find(({ id }) => image.assessorID === id);
      // this.deletePhotos([image.id]);
      delete this.user.medias[image.id];
      this.updateUser(this.user.medias);

      // assessor in which photos will be deleted.
      const assessor = this.assessors.find(
        (assessor) => assessor.data.medias && Object.keys(assessor.data.medias).includes(image.id),
      );

      const assessorMedia = Object.fromEntries(
        Object.entries(assessor.data.medias).filter(([key, value]) => key !== image.id),
      );

      const updatedAssessor = {
        evaluationId: image.evaluationID,
        groupId: image.groupID,
        assessor: {
          ...assessor,
          data: {
            ...assessor.data,
            medias: assessorMedia,
          },
        },
      };
      this[GET_UPDATE_ASSESSOR](updatedAssessor);
      this.$forceUpdate();
    },

    filter() {
      var originals = this.originals;
      if (this.filterEval) {
        originals = originals.filter((item) => item.evaluationID === this.filterEval);
      } else {
        originals = originals.filter((item) => item.evaluationID != null);
      }
      if (this.filterAssessor) {
        originals = originals.filter((item) => item.assessorType === this.filterAssessor);
      } else {
        originals = originals.filter((item) => item.evaluationID != null);
      }

      if (this.images.length !== 5) {
        this.images = originals;
      } else {
        this.images = this.images;
      }

      this.notFiltered = false;
    },

    toggleModal(image) {
      console.log(image);
      this.modalImage = image;
      if (this.modalImage.comment) {
        this.showComment = true;
      } else {
        this.showComment = false;
      }
    },

    addComment(image) {
      const updatedMedia = {
        [image.id]: {
          ...image,
          comment: image.comment,
          id: image.id,
          photoName: image.photoName,
        },
      };

      this.updateUser({ ...this.user.medias, ...updatedMedia });
    },

    updateUser(medias) {
      if (this.userType === 'user') {
        this[GET_UPDATE_ME]({
          medias,
        });
      } else {
        this[GET_UPDATE_CUSTOMER]({
          ...this.user,
          medias,
        });
        this.$set(this.user, 'medias', medias);
        this.getMedia();
      }
    },

    getMedia() {
      const { medias } = this.user;
      let userMedias = (this.user || this.loggedInCustomer).medias;
      if (userMedias === undefined) {
        userMedias = [];
      }
      if (medias && Object.keys(medias).length) {
        this.images = this.getData();
        console.log(this.images);
      } else {
        this.images = [];
      }
    },

    getData() {
      let buildMedias = [];
      this.groups = [];
      this.assessors = [];

      let counter = 0;

      if (this.evaluations !== undefined) {
        this.evaluations.forEach((evaluation) => {
          let evaluationName = evaluation.name;
          let evaluationID = evaluation._id;

          if (evaluation.groups !== undefined) {
            for (const groupKey in evaluation.groups) {
              let group = evaluation.groups[groupKey];
              let groupName = group.name;
              let groupID = group.id;
              this.groups.push(group);

              if (group.assessors !== undefined) {
                for (const assessorKey in group.assessors) {
                  let assessor = group.assessors[assessorKey];
                  let assessorName = '';
                  let assessorID = assessor.id;
                  let assessorType = assessor.type;
                  switch (assessorType) {
                    case '1':
                      assessorName = 'Hygiene/Footbath';
                      break;
                    case '2':
                      assessorName = 'Freestall';
                      break;
                    case '3':
                      assessorName = 'Locomotion';
                      break;
                    case '4':
                      assessorName = 'Time Budget';
                      break;
                    case '11':
                      assessorName = 'Holding Area';
                      break;
                    case '14':
                      assessorName = 'Nutrition and Feeding';
                      break;
                    case '13':
                      assessorName = 'Tiestall/Stanchion Heat Abatement';
                      break;
                    case '15':
                      assessorName = 'Hoof Trimming';
                      break;
                    case '17':
                      assessorName = 'Lesion';
                      break;
                    case '18':
                      assessorName = 'Walking Surface';
                      break;
                    case '9':
                      assessorName = 'Races, Tracks and Lanes';
                      break;
                    case '12':
                      assessorName = 'Freestall Ventilation';
                      break;
                    case '10':
                      assessorName = 'Tie Stall/Stanchion';
                      break;
                    case '16':
                      assessorName = 'Heat Abatement';
                      break;
                    case '7':
                      assessorName = 'Bedded Pack';
                      break;
                      break;
                    case '5':
                      assessorName = 'Dirt Lot';
                      break;
                    default:
                      assessorName = 'Not Found';
                      break;
                  }

                  this.assessors.push(assessor);

                  if (typeof assessor.data.medias !== 'undefined') {
                    let foundMedia = {};
                    for (const mediaKey in assessor.data.medias) {
                      foundMedia = this.medias[assessor.data.medias[mediaKey]];
                      console.log(foundMedia);
                      if (
                        foundMedia &&
                        foundMedia.base64 &&
                        foundMedia.base64.startsWith('data:image')
                      ) {
                        foundMedia.evaluationName = evaluationName;
                        foundMedia.groupName = groupName;
                        foundMedia.assessorName = assessorName;
                        foundMedia.assessorID = assessorID;
                        foundMedia.groupID = groupID;
                        foundMedia.evaluationID = evaluationID;
                        foundMedia.displayDate = new Date(foundMedia.time).toDateString();
                        foundMedia.sortingID = counter;
                        foundMedia.assessorType = assessorType;
                        buildMedias.push(this.medias[assessor.data.medias[mediaKey]]);
                        counter++;
                      }
                    }
                  }
                }
              }
            }
          }
        });
      }

      this.originals = buildMedias;
      return buildMedias;
    },
  },
  created() {
    this.getUserData();
  },
  watch: {
    user: function (newValue) {
      this.images = null;
      this.getUserData();
    },
  },
};
</script>
